<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate"
                         v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                         v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Vendor</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :disabled="true"
              />
            </div>
            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button label="Search" class="p-button-raised p-button-rounded" type="submit" lable="Search"
                      @click.prevent="searchDelivery"></Button>
            </div>
            <div class="p-field p-col-12">
              <a href="#" @click.prevent="exportCSV()" v-if="this.deliveryList.length > 0">
                <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
              </a>
            </div>


          </div>

          <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>


            <div class="p-fluid p-formgrid p-grid" style="flex-flow: row-reverse;">
              <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-danger" @click.prevent="cancel"
                        label="Cancel"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-success" @click.prevent="updateOrderStatus"
                        label="Update"/>
              </div>

            </div>

          </Dialogs>
        </form>

        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <DataTable :value="deliveryList" dataKey="id" ref="dt" :selection.sync="selectedDeliveryId"
                       :paginator="true" editMode="cell"
                       class="p-datatable-gridlines"
                       :rows="10" :filters="filters">
              <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="deliveryDateNepali"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryDateNepali']"/>
                </template>
              </Column>
              <Column header="Del Code" :sortable="true" field="orderCode" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderCode']"/>
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
                <!-- <template #filter>
                     <InputText type="text" class="p-column-filter" v-model="filters['customerName']" />
                 </template> -->
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['customerName']" @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['address']" @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Contact" :sortable="true" field="primaryContact" filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['primaryContact']" @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['primaryContact']"/>
                </template>
              </Column>

              <Column header="Amount" bodyStyle="text-align: right" :sortable="true" field="billAmount"
                      filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['billAmount']" @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
                </template>
              </Column>
              <Column header="Payable Amt" bodyStyle="text-align: right" :sortable="true" field="payableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['payableAmount']"/>
                </template>
              </Column>
              <Column header="Del Charge" bodyStyle="text-align: right" :sortable="true" field="deliveryChargeAmount"
                      filterMatchMode="contains">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['deliveryChargeAmount']"
                             @change="updateAssignedToUser(slotProps.data)"/>
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryChargeAmount']"/>
                </template>
              </Column>

              <Column field="orderStatus" header="Status" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['orderStatus']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['orderStatus']" :options="statuses"
                            @change="showReasonDialog(slotProps.data)"
                            optionLabel="label" optionValue="value" placeholder="Select status"
                            :disabled="slotProps.data['orderStatus']==='Completed'?true:false">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getStatusLabel(slotProps.data.orderStatus) }}
                </template>

              </Column>
              <Column field="assignToName" header="Assign To" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['assignToName']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['assignedTo']" :options="userList"
                            @change="updateAssignedToUser(slotProps.data)"
                            optionLabel="username" optionValue="id" placeholder="Select rider">
                    <template #option="slotProps">
                      <span :class="'product-badge status-'">{{ slotProps.option.username }}</span>
                    </template>
                  </Dropdown>
                </template>
              </Column>
              <Column header="Store" field="storeName">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['storeName']"/>
                </template>
              </Column>
              <Column header="Remarks" field="remarks">
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data['remarks']" @click="showDialogForRemarks(slotProps.data)"/>
                </template>
              </Column>
            </DataTable>
            <div class="p-grid p-col-12 p-md-3 p-mt-2">
              <Button v-if="enableSettle" class="p-button-raised p-button-success" label="Update Paid"
                      @click.prevent="updatePaidStatus()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Button from 'primevue/button'

export default {
  name: 'deliveryReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      deliveryList: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForDelivery: [],
      deliveryOrderLists: [],
      selectedDeliveryId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      paymentStatusData: '',
      paymentMethod: '',
      inventoryHeaderId: null,
      assignedTo: null,
      assignedToId: 0,
      deliveryCharge: null,
      enableSettle: false,
      customerName: '',
      address: '',
      primaryContact: '',
      billAmount: null,
      setWarehouseData: false,
      warehouseId: null,
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {
        label: 'Completed',
        value: 'Completed'
      }, {label: 'Cancelled', value: 'Cancelled'},
        {label: 'Assigned To Rider', value: 'AssignedToRider'}, {
          label: 'Received By Store',
          value: 'ReceivedByStore'
        }, {label: 'Received By Rider', value: 'ReceivedByRider'}, {
          label: 'Returned To Vendor',
          value: 'ReturnedToVendor'
        }],
      statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'COD', value: 'COD'}, {
        label: 'HalfPayment',
        value: 'HalfPayment'
      }],
      paymentMethods: [{label: 'Cash', value: 'Cash'}, {label: 'Esewa', value: 'Esewa'}, {
        label: 'Khalti',
        value: 'Khalti'
      }, {label: 'Bank', value: 'Bank'}, {label: 'Other', value: 'Other'}]
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableSettle()
    this.warehouseList()
    this.setWarehouse()
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  methods: {
    async searchDelivery() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        warehouse: this.id
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadDeliveryDetailsLists', dat)
      let users = await this.$store.dispatch('loadRiderUser')
      this.loading = false
      this.userList = users.data.data
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.deliveryList = []
      } else {
        this.deliveryList = resp.data.data
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    showReasonDialog(data) {
      if (data.assignedTo === undefined) {
        this.assignedToId = 0
      } else {
        this.assignedToId = data.assignedTo.id
      }
      this.inventoryHeaderId = data.id
      this.ecommerceStatusData = data.orderStatus
      this.paymentStatusData = data.paymentStatus
      this.billAmount = data.billAmount
      this.paymentMethod = data.paymentMethod
      this.remarks = data.remarks
      this.customerName = data.customerName
      this.address = data.address
      this.primaryContact = data.primaryContact
      if (data.orderStatus === 'Hold' || data.orderStatus === 'Cancelled') {
        this.ecommerceStatusDialog = true
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.orderStatus
        this.paymentStatusData = data.paymentStatus
        this.paymentMethod = data.paymentMethod
        this.deliveryCharge = data.deliveryChargeAmount
      } else {
        this.reason = '-'
        this.deliveryCharge = data.deliveryChargeAmount
        this.updateOrderStatus()
      }
    },
    showDialogForRemarks(data) {
      if (data.assignedTo === undefined) {
        this.assignedToId = 0
      } else {
        this.assignedToId = data.assignedTo.id
      }
      if (data.remarks !== null) {
        this.reason = data.remarks
        this.inventoryHeaderId = data.id
        this.ecommerceStatusData = data.orderStatus
        this.paymentStatusData = data.paymentStatus
        this.paymentMethod = data.paymentMethod
        this.ecommerceStatusDialog = true
        this.deliveryCharge = data.deliveryChargeAmount
        this.billAmount = data.billAmount
        this.customerName = data.customerName
        this.address = data.address
        this.primaryContact = data.primaryContact
      }
    },
    async updateOrderStatus() {
      if (this.assignedTo === null) {
        this.assignedToId = 0
      } else {
        this.assignedToId = this.assignedTo.id
      }
      let data = {
        inventoryHeaderId: this.inventoryHeaderId,
        statusType: this.ecommerceStatusData,
        reason: this.reason,
        assignedTo: this.assignedToId,
        paymentStatus: this.paymentStatusData,
        deliveryCharge: this.deliveryCharge,
        billAmount: this.billAmount,
        paymentMethod: this.paymentMethod,
        customerName: this.customerName,
        address: this.address,
        primaryContact: this.primaryContact
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reason = ''
        this.ecommerceStatusDialog = false
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Processing':
          return 'Processing'

        case 'Hold':
          return 'Hold'

        case 'Completed':
          return 'Completed'

        case 'Cancelled':
          return 'Cancelled'

        case 'AssignedToRider':
          return 'Assigned To Rider'

        case 'ReceivedByStore':
          return 'Received By Store'

        case 'ReceivedByRider':
          return 'Received By Rider'

        case 'ReturnedToVendor':
          return 'Returned To Vendor'

        default:
          return 'NA'
      }
    },
    getPayStatusLabel(payStatus) {
      switch (payStatus) {
        case 'Paid':
          return 'Paid'

        case 'COD':
          return 'COD'

        case 'HalfPayment':
          return 'Half Paid'

        default:
          return 'NA'
      }
    },
    getPayMethodsLabel(payMethods) {
      switch (payMethods) {
        case 'Cash':
          return 'Cash'

        case 'Esewa':
          return 'Esewa'

        case 'Khalti':
          return 'Khalti'

        case 'Bank':
          return 'Bank'

        case 'Other':
          return 'Other'

        default:
          return 'NA'
      }
    },
    async updateAssignedToUser(data) {
      // if (data.assignedTo === undefined) {
      //   this.assignedToId = 0
      // } else {
      //   this.assignedToId = data.assignedTo.id
      // }
      // if (this.assignedToId === undefined) {
      //   this.assignedToId = data.assignedTo.id
      // }
      let userData = {
        inventoryHeaderId: data.id,
        statusType: data.orderStatus,
        reason: data.remarks,
        assignedTo: data.assignedTo,
        paymentStatus: data.paymentStatus,
        deliveryCharge: data.deliveryChargeAmount,
        billAmount: data.billAmount,
        paymentMethod: data.paymentMethod,
        customerName: data.customerName,
        address: data.address,
        primaryContact: data.primaryContact
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    async updatePaidStatus() {
      if (this.selectedDeliveryId !== null) {
        this.selectedDeliveryId.forEach(deliveryOrderId => this.idsForDelivery.push(deliveryOrderId.id))
      }
      if (this.idsForDelivery.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one delivery!', life: 10000})
        return
      }
      let userData = {
        idsForDelivery: this.idsForDelivery
      }
      let resp = await this.$store.dispatch('updatePaidForVendor', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.idsForDelivery = ''
        this.selectedDeliveryId = ''
        // this.ecommerceStatusDialog = false
      }
    },
    async updatePaymentStatus(data) {
      if (data.assignedTo === undefined) {
        this.assignedToId = 0
        // this.$toast.add({severity: 'success', summary: '', detail: 'Please assign to rider first!', life: 10000})
        // return
      } else {
        this.assignedToId = data.assignedTo.id
      }
      let userData = {
        inventoryHeaderId: data.id,
        statusType: data.orderStatus,
        reason: data.remarks,
        assignedTo: data.assignedTo,
        paymentStatus: data.paymentStatus,
        deliveryCharge: data.deliveryChargeAmount,
        billAmount: data.billAmount,
        paymentMethod: data.paymentMethod,
        customerName: data.customerName,
        address: data.address,
        primaryContact: data.primaryContact
      }
      let resp = await this.$store.dispatch('updateStatusByAdmin', userData)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        // this.ecommerceStatusDialog = false
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportForRequest/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/AllDeliveryReport' + '/' + this.$store.getters.fyId + '/' + this.$store.getters.warehouseId.id + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'AllDeliveryReport.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    checkEnableSettle() {
      if (this.$store.getters.modules.includes(',6.11')) {
        this.enableSettle = true
      }
    },
    selectedSalesOrder(data) {
      // this.selectedDeliveryId.push(data.id)
      if (!this.idsForDelivery.includes(data)) {
        this.idsForDelivery.push(data)
      }
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.deliveryList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Dropdown,
    Dialogs,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// deliveryReport.vue?1a6d5f03